import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c7e57e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "purchase-authorization-list py-56" }
const _hoisted_2 = { class: "d-flex mb-56 justify-content-between" }
const _hoisted_3 = { class: "h4 text-primary mb-0" }
const _hoisted_4 = { class: "fw-normal" }
const _hoisted_5 = { class: "row gx-24" }
const _hoisted_6 = { class: "col-12 col-lg-4 mb-24" }
const _hoisted_7 = { class: "form-label" }
const _hoisted_8 = { class: "col-12 col-lg-4 mb-24" }
const _hoisted_9 = { class: "form-label" }
const _hoisted_10 = { class: "col-12 col-lg-4 mb-24" }
const _hoisted_11 = { class: "form-label" }
const _hoisted_12 = { class: "row gx-24" }
const _hoisted_13 = { class: "text-end mb-24" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "icon icon-import me-8"
}, null, -1))
const _hoisted_15 = { class: "fw-normal" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "icon icon-import me-8"
}, null, -1))
const _hoisted_17 = { class: "fw-normal" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "icon icon-import me-8"
}, null, -1))
const _hoisted_19 = { class: "fw-normal" }
const _hoisted_20 = { class: "purchases-list" }
const _hoisted_21 = { class: "table-responsive mb-16" }
const _hoisted_22 = { class: "fit" }
const _hoisted_23 = { class: "fit text-center" }
const _hoisted_24 = { class: "fit text-center" }
const _hoisted_25 = { class: "fit text-center" }
const _hoisted_26 = { class: "fit text-center" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "fit text-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon icon-blank-alt-light fw-bold" })
], -1))
const _hoisted_28 = {
  key: 0,
  class: "empty-state py-8 px-12 text-center",
  colspan: "222222"
}
const _hoisted_29 = { class: "h-100 w-100 d-flex flex-column align-items-center justify-content-center text-center" }
const _hoisted_30 = { class: "position-relative py-40 w-100" }
const _hoisted_31 = { key: 1 }
const _hoisted_32 = {
  class: "empty-state py-8 px-12 text-center",
  colspan: "222222"
}
const _hoisted_33 = { class: "h-100 w-100 d-flex flex-column align-items-center justify-content-center text-center" }
const _hoisted_34 = { class: "h5 title text-primary mb-48" }
const _hoisted_35 = { class: "fit text-center" }
const _hoisted_36 = { class: "fit text-center" }
const _hoisted_37 = { class: "fit text-center" }
const _hoisted_38 = { class: "fit text-center" }
const _hoisted_39 = { class: "fit text-center" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "icon icon-view-light"
}, null, -1))
const _hoisted_41 = { class: "fw-normal" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_loader = _resolveComponent("v-loader")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_form_group_select = _resolveComponent("v-form-group-select")!
  const _component_v_form_group_input_date = _resolveComponent("v-form-group-input-date")!
  const _component_v_button = _resolveComponent("v-button")!
  const _component_v_table_header = _resolveComponent("v-table-header")!
  const _component_v_table_body = _resolveComponent("v-table-body")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_pagination = _resolveComponent("v-pagination")!
  const _component_the_admin_purchase_authorization_show = _resolveComponent("the-admin-purchase-authorization-show")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('Listado de')), 1),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('autorizaciones de compra')), 1)
      ])
    ]),
    (!_ctx.loaded)
      ? (_openBlock(), _createBlock(_component_v_loader, { key: 0 }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('Profesionales')), 1),
              _createVNode(_component_v_form_group_select, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_select, {
                    modelValue: _ctx.filters.professionals,
                    "onUpdate:modelValue": [
                      _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.professionals) = $event)),
                      _cache[1] || (_cache[1] = ($event: any) => (_ctx.search()))
                    ],
                    options: _ctx.availableProfessionalOptions,
                    reduce: returnValue => returnValue.key,
                    "select-on-key-codes": [188, 13],
                    multiple: ""
                  }, {
                    "no-options": _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('No se han encontrado resultados')), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "options", "reduce"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('Pacientes')), 1),
              _createVNode(_component_v_form_group_select, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_select, {
                    modelValue: _ctx.filters.patients,
                    "onUpdate:modelValue": [
                      _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.patients) = $event)),
                      _cache[3] || (_cache[3] = ($event: any) => (_ctx.search()))
                    ],
                    options: _ctx.availablePatientOptions,
                    reduce: returnValue => returnValue.key,
                    "select-on-key-codes": [188, 13],
                    multiple: ""
                  }, {
                    "no-options": _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('No se han encontrado resultados')), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "options", "reduce"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('Estado')), 1),
              _createVNode(_component_v_form_group_select, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_select, {
                    modelValue: _ctx.filters.status,
                    "onUpdate:modelValue": [
                      _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters.status) = $event)),
                      _cache[5] || (_cache[5] = ($event: any) => (_ctx.search()))
                    ],
                    options: _ctx.availableStatusOptions,
                    reduce: returnValue => returnValue.key,
                    "select-on-key-codes": [188, 13],
                    multiple: ""
                  }, {
                    "no-options": _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('No se han encontrado resultados')), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "options", "reduce"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_v_form_group_input_date, {
              label: _ctx.$t('Emitida desde'),
              value: _ctx.filters.created_at.start_at,
              class: "col-12 col-md-6 col-lg-3 mb-24",
              "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => {_ctx.filters.created_at.start_at = _ctx.parseDate($event); _ctx.search()})
            }, null, 8, ["label", "value"]),
            _createVNode(_component_v_form_group_input_date, {
              label: _ctx.$t('Emitida hasta'),
              value: _ctx.filters.created_at.end_at,
              class: "col-12 col-md-6 col-lg-3 mb-24",
              "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => {_ctx.filters.created_at.end_at = $event; _ctx.search()})
            }, null, 8, ["label", "value"]),
            _createVNode(_component_v_form_group_input_date, {
              label: _ctx.$t('Vencido desde'),
              value: _ctx.filters.due_date.start_at,
              class: "col-12 col-md-6 col-lg-3 mb-24",
              "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => {_ctx.filters.due_date.start_at = $event; _ctx.search()})
            }, null, 8, ["label", "value"]),
            _createVNode(_component_v_form_group_input_date, {
              label: _ctx.$t('Vencido hasta'),
              value: _ctx.filters.due_date.end_at,
              class: "col-12 col-md-6 col-lg-3 mb-24",
              "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => {_ctx.filters.due_date.end_at = $event; _ctx.search()})
            }, null, 8, ["label", "value"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_v_button, {
              "aria-label": _ctx.$t('Descargar excel agrupado'),
              class: "btn-icon me-24",
              variant: "primary",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.downloadReport({
          url: 'api/admin/purchase-authorizations-export',
          name: 'purchase-authorizations',
          })))
            }, {
              default: _withCtx(() => [
                _hoisted_14,
                _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('Descargar excel agrupado')), 1)
              ]),
              _: 1
            }, 8, ["aria-label"]),
            _createVNode(_component_v_button, {
              "aria-label": _ctx.$t('Descargar excel detallado'),
              class: "btn-icon me-24",
              variant: "primary",
              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.downloadReport({
          url: 'api/admin/purchase-authorizations-export-detail',
          name: 'purchase-authorizations-detail',
          })))
            }, {
              default: _withCtx(() => [
                _hoisted_16,
                _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('Descargar excel detallado')), 1)
              ]),
              _: 1
            }, 8, ["aria-label"]),
            _createVNode(_component_v_button, {
              "aria-label": _ctx.$t('Descargar excel listado profesionales'),
              class: "btn-icon",
              variant: "primary",
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.downloadReport({
          url: 'api/admin/professional-purchase-authorizations-export',
          name: 'professional-purchase-authorizations',
          })))
            }, {
              default: _withCtx(() => [
                _hoisted_18,
                _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t('Descargar excel listado profesionales')), 1)
              ]),
              _: 1
            }, 8, ["aria-label"])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_component_v_table, { class: "table-bordered" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_table_header, null, {
                    default: _withCtx(() => [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_22, _toDisplayString(_ctx.$t('ID')), 1),
                        _createElementVNode("th", _hoisted_23, _toDisplayString(_ctx.$t('Emitida')), 1),
                        _createElementVNode("th", _hoisted_24, _toDisplayString(_ctx.$t('Vencimiento')), 1),
                        _createElementVNode("th", _hoisted_25, _toDisplayString(_ctx.$t('Profesional')), 1),
                        _createElementVNode("th", _hoisted_26, _toDisplayString(_ctx.$t('Paciente')), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.$t('Productos')), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.$t('Subtotal')), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.$t('Impuestos')), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.$t('Estado')), 1),
                        _hoisted_27
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_table_body, null, {
                    default: _withCtx(() => [
                      (!_ctx.loadedSearch)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_28, [
                            _createElementVNode("div", _hoisted_29, [
                              _createElementVNode("div", _hoisted_30, [
                                _createVNode(_component_v_loader)
                              ])
                            ])
                          ]))
                        : (!_ctx.purchaseAuthorizations || !_ctx.purchaseAuthorizations.length)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_31, [
                              _createElementVNode("td", _hoisted_32, [
                                _createElementVNode("div", _hoisted_33, [
                                  _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.$t('No hay autorizaciones de compra')), 1)
                                ])
                              ])
                            ]))
                          : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.purchaseAuthorizations, (purchaseAuthorization) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: purchaseAuthorization.id
                              }, [
                                _createElementVNode("td", null, _toDisplayString(purchaseAuthorization.id), 1),
                                _createElementVNode("td", _hoisted_35, _toDisplayString(_ctx.$str.formatDate(purchaseAuthorization.createdAt)), 1),
                                _createElementVNode("td", _hoisted_36, _toDisplayString(_ctx.$str.formatDate(purchaseAuthorization.dueDate)), 1),
                                _createElementVNode("td", _hoisted_37, _toDisplayString(purchaseAuthorization.professional?.user?.name) + " " + _toDisplayString(purchaseAuthorization.professional?.user?.surname), 1),
                                _createElementVNode("td", _hoisted_38, _toDisplayString(purchaseAuthorization.patient?.user?.name) + " " + _toDisplayString(purchaseAuthorization.patient?.user?.surname), 1),
                                _createElementVNode("td", null, _toDisplayString(_ctx.$t('{count} productos distintos', { count: purchaseAuthorization.products.length })), 1),
                                _createElementVNode("td", null, _toDisplayString((purchaseAuthorization.subtotal / 100)) + _toDisplayString(_ctx.$t('€')), 1),
                                _createElementVNode("td", null, _toDisplayString((purchaseAuthorization.subtotalTaxes / 100)) + _toDisplayString(_ctx.$t('€')), 1),
                                _createElementVNode("td", null, _toDisplayString(_ctx.status(purchaseAuthorization.status)), 1),
                                _createElementVNode("td", _hoisted_39, [
                                  _createVNode(_component_v_button, {
                                    "aria-label": _ctx.$t('Visualizar'),
                                    class: "d-flex flex-column p-0 m-auto",
                                    variant: "icon",
                                    onClick: ($event: any) => (_ctx.showPurchaseAuthorizationShowModal(purchaseAuthorization))
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_40,
                                      _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.$t('Ver')), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["aria-label", "onClick"])
                                ])
                              ]))
                            }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            (_ctx.purchaseAuthorizations.length > 0)
              ? (_openBlock(), _createBlock(_component_v_pagination, {
                  key: 0,
                  meta: _ctx.purchaseAuthorizationsPagination?.meta,
                  pagination: _ctx.purchaseAuthorizationsPagination?.pagination,
                  onPageChanged: _ctx.handlePageChangedEvent
                }, null, 8, ["meta", "pagination", "onPageChanged"]))
              : _createCommentVNode("", true)
          ])
        ], 64)),
    (_ctx.modalToShow === 'the-admin-purchase-authorization-show')
      ? (_openBlock(), _createBlock(_component_the_admin_purchase_authorization_show, {
          key: 2,
          "purchase-authorization": _ctx.selectedPurchase,
          onClosed: _cache[13] || (_cache[13] = ($event: any) => {_ctx.modalToShow = null; _ctx.selectPurchase(null)})
        }, null, 8, ["purchase-authorization"]))
      : _createCommentVNode("", true)
  ]))
}